/**
 * .c-input--toggle では、パスワードの表示・非表示の切り替えをできるようにします
 * @returns { void }
 */
export const inputPassword = () => {
  const elements = document.querySelectorAll( '.c-input--toggle' );

  elements.forEach( element => {
    const addHtml = '<button class="c-icon c-icon--password-show"></button>';
    element.outerHTML = `<div class="c-input__wrap">` + element.outerHTML + addHtml + `</div>`;
  } );

  const elements2 = document.querySelectorAll( '.c-input--toggle' );

  elements2.forEach( element => {
    const parent = element.closest( '.c-input__wrap' );
    const toggleButton = parent.querySelector( 'button' );

    toggleButton.addEventListener( 'click', ( e ) => {
      if ( e.target.classList.contains( 'c-icon--password-show' ) ) {
        e.target.classList.remove( 'c-icon--password-show' );
        e.target.classList.add( 'c-icon--password-hide' );
        element.setAttribute( 'type', 'text' );
      } else {
        e.target.classList.remove( 'c-icon--password-hide' );
        e.target.classList.add( 'c-icon--password-show' );
        element.setAttribute( 'type', 'password' );
      }
    } );
  } );
}
